import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a network error that should be suppressed
    if (error && (
      error.message?.includes('NetworkError') ||
      error.message?.includes('fetch') ||
      error.message?.includes('Failed to fetch') ||
      error.message?.includes('ERR_NETWORK') ||
      error._suppressUserError ||
      error._isHandled
    )) {
      // Don't trigger error boundary for network errors
      return null;
    }
    
    // Oppdater state slik at neste render viser fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Check if it's a network error that should be suppressed
    if (error && (
      error.message?.includes('NetworkError') ||
      error.message?.includes('fetch') ||
      error.message?.includes('Failed to fetch') ||
      error.message?.includes('ERR_NETWORK') ||
      error._suppressUserError ||
      error._isHandled
    )) {
      // Silently handle network errors
      if (process.env.NODE_ENV === 'development') {
        console.warn("ErrorBoundary suppressed network error", error, errorInfo);
      }
      return;
    }
    
    // Du kan logge feilen til en ekstern feillogg her
    console.log("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Du kan rendere fallback-UI her
      return <h1>Something unexpected happened.</h1>;
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
